// removed by extract-text-webpack-plugin
module.exports = {"watermarkBackground":"_2ZKZzxmk9bGl045dLNYWbx","watermarkSign":"_20rdY7ysItszGShTYfZGMH","watermarkBackgroundMuted":"_2jbyZWb9zSUUWqsLk3oZqG","legendLine":"_2RRFsLInA9GSykTQTq-ZwZ","legend":"_3-lQEZFV4ZeOIbT3OSgLEg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectLegendLine/ProjectLegendLine.scss
// module id = 1298
// module chunks = 1